import React from 'react';
import { useNavigate } from '@tanstack/react-router';
import { ActingQueryData } from '@area-restrita/api-client/model/actingQueryData';
import { getGetActingsQueryOptions } from '@area-restrita/api-client/endpoints/actings/actings.gen';

import { useAuthSessionStore } from '@/modules/authentication/stores/authSessionStore';
import PageContainer from '@/components/layout/PageContainer';
import DataGrid from '@/components/DataGrid';
import { useQueryTable } from '@/hooks/useQueryTable';

import { columns } from './columns';
import ActingReport from './ActingReport';
import { Button } from '@/components/ui/button';
import { Download } from 'lucide-react';

const Actings: React.FC = () => {
  const navigate = useNavigate();
  const { checkAuthorization } = useAuthSessionStore();

  const canViewDetails = checkAuthorization(({ can }) =>
    can('viewDetails', 'actings'),
  );

  const {
    query: { isLoading },
    table,
  } = useQueryTable({
    columns,
    getQueryOptions: getGetActingsQueryOptions,
  });

  return (
    <PageContainer title="Execuções de rotas" subtitle="Gerenciar Atividades">
      <DataGrid
        variant="card"
        table={table}
        isLoading={isLoading}
        // toolbar={
        //   <div className="flex items-center space-x-2">
        //     <DataTableFacetedFilter
        //       title="Status"
        //       options={statusOptions}
        //       column={table.getColumn('status')}
        //     />
        //   </div>
        // }
        actions={
          canViewDetails && (
            <ActingReport>
              <Button size="sm">
                <Download className="mr-2 h-4 w-4" />
                Gerar relatório
              </Button>
            </ActingReport>
          )
        }
        onRowClick={
          canViewDetails &&
          ((row: ActingQueryData) => {
            navigate({
              to: '/actings/$actingId',
              params: { actingId: row.id },
            });
          })
        }
      />
    </PageContainer>
  );

  // return (
  //   <PageDataTable
  //     title="Actings"
  //     queryOptionsFn={getActings}
  //     AddTrigger={ActingReport}
  //     addTriggerText="Generate report"
  //     canCreate={true}
  //     emptyState={{
  //       title: 'No actions found',
  //       actionDescription:
  //         'Initiate a new acting on driver app to get started.',
  //     }}
  //     filters={[
  //       { columnId: 'prefix', title: 'Prefix', options: [] },
  //       { columnId: 'company', title: 'Company', options: [] },
  //     ]}
  //     onRowClick={({ id }): void => {
  //       navigate({ to: '/actings/$actingId', params: { actingId: id } });
  //     }}
  //     columns={columns}
  //     seachColumnId="name"
  //     searchPlaceholder="Filter buslines"
  //   />
  // );
};

export default Actings;
